import {useLayoutEffect,useSyncExternalStore} from 'react';
import {presentations} from './presentationCoordinator';
export const usePresentationState=()=>useSyncExternalStore(presentations.subscribe,presentations.getSnapshot,presentations.getSnapshot);
export function usePresentationHold(active:boolean,returnLabel='Back to the map'){
 useLayoutEffect(()=>active?presentations.hold(returnLabel):undefined,[active,returnLabel]);
}
